Month: <p-dropdown [options]="monthOptions" [(ngModel)]="selectedMonth"></p-dropdown>
Year: <p-dropdown [options]="yearOptions" [(ngModel)]="selectedYear" (onChange)="refreshMonthOptions()"></p-dropdown>
<div>
    <p-radioButton name="option" label=".xlsx" value="1" [(ngModel)]="selectedOption"></p-radioButton>
    <p-radioButton name="option" label=".csv" value="2" [(ngModel)]="selectedOption"></p-radioButton>
</div>
<p-button label="Export" (onClick)="exportFile()"></p-button>